module.exports = __webpack_public_path__ + "media/images/emprelatam_fondo-82efda56.png";